const TARGET_BYTES = 1_200_000;
const MAX_DIMENSION = 2000;
export const MAX_SOURCE_PHOTO_BYTES = 15 * 1024 * 1024;

function canvasBlob(canvas: HTMLCanvasElement, quality: number): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("PHOTO_CONVERSION_FAILED"))), "image/jpeg", quality);
  });
}

export async function preparePhoto(file: File): Promise<File> {
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    throw new Error("PHOTO_DECODE_FAILED");
  }
  try {
    const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("PHOTO_CONVERSION_FAILED");
    context.drawImage(bitmap, 0, 0, width, height);

    let quality = 0.84;
    let blob = await canvasBlob(canvas, quality);
    while (blob.size > TARGET_BYTES && quality > 0.54) {
      quality -= 0.08;
      blob = await canvasBlob(canvas, quality);
    }
    return new File([blob], "entry-photo.jpg", { type: "image/jpeg", lastModified: Date.now() });
  } finally {
    bitmap.close();
  }
}
